<template>
    <div>
      <vue-good-wizard 
        :steps="steps"
        :onNext="nextClicked" 
        :onBack="backClicked"
        :nextStepLabel="nextStepLabel"
        :previousStepLabel="previousStepLabel"
        :finalStepLabel="finalStepLabel">
        <div slot="page1">
          <div class="form-datos">
              <div class="input" :class="{invalid: $v.proceso.sentencia.$error}">
                  <label for="sentencia">Origen del estudio *</label>
                  <input type="text" id="sentencia" @blur="$v.proceso.sentencia.$touch()" placeholder="Sentencia o Consiliación" class="form-control required" v-model="proceso.sentencia"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.jurisdiccion.$error}">
                  <label for="jurisdiccion">Jurisdicción *</label>
                  <input type="text" id="jurisdiccion" @blur="$v.proceso.jurisdiccion.$touch()" placeholder="Ordinaria o Contensioso Administrativa" class="form-control required" v-model="proceso.jurisdiccion"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.afiliado.$error}">
                  <label for="afiliado">Nombre Afiliado *</label>
                  <input type="text" id="afiliado" @blur="$v.proceso.afiliado.$touch()" placeholder="Afiliado" class="form-control required" v-model="proceso.afiliado"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.cedula.$error}">
                  <label for="cedula">Identificación *</label>
                  <input type="text" id="cedula" @blur="$v.proceso.cedula.$touch()" placeholder="Cédula" class="form-control required" v-model="proceso.cedula"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.radicado.$error}">
                  <label for="radicado">Radicado *</label>
                  <input type="text" id="radicado" @blur="$v.proceso.radicado.$touch()" placeholder="Radicado" class="form-control required" v-model="proceso.radicado"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.despacho1.$error}">
                  <label for="desacho1">Despacho 1a instancia *</label>
                  <input type="text" id="despacho1" @blur="$v.proceso.despacho1.$touch()" placeholder="Despacho primera instancia" class="form-control required" v-model="proceso.despacho1"/>
              </div>
              <div class="input" >
                  <label for="desacho2">Despacho 2a instancia *</label>
                  <input type="text" id="despacho2" @blur="$v.proceso.despacho2.$touch()" placeholder="Despacho segunda instancia" class="form-control required" v-model="proceso.despacho2"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.fechaFallo1.$error}">
                  <label for="fecha1">Fecha Fallo 1a instancia *</label>
                  <input type="text" id="fecha1" @blur="$v.proceso.fechaFallo1.$touch()" placeholder="Fecha Fallo primera instancia" class="form-control required" v-model="proceso.fechaFallo1"/>
              </div> 
              <div class="input" >
                  <label for="fecha2">Fecha Fallo 2a instancia *</label>
                  <input type="text" id="fecha2" @blur="$v.proceso.fechaFallo2.$touch()" placeholder="Fecha Fallo segunda instancia" class="form-control required" v-model="proceso.fechaFallo2"/>
              </div>
              <div class="input" :class="{invalid: $v.proceso.pretension.$error}">
                  <label for="pretension">Pretensión *</label>
                  <input type="text" id="pretension" @blur="$v.proceso.pretension.$touch()" placeholder="Pretensión" class="form-control required" v-model="proceso.pretension"/>
              </div>
          </div>
        </div>
        <div slot="page2">
          <div class="form-datos">
            <h4>Presunto Responsable</h4>
              <div class="input" :class="{invalid: $v.responsable.nombre.$error}">
                  <label for="responsable">Nombre *</label>
                  <input type="text" id="responsable" @blur="$v.responsable.nombre.$touch()" placeholder="Nombre" class="form-control required" v-model="responsable.nombre"/>
              </div>
              
              <div class="input" :class="{invalid: $v.responsable.cargo.$error}">
                  <label for="responsableCargo">Cargo *</label>
                  <input type="text" id="responsableCargo" @blur="$v.responsable.cargo.$touch()" placeholder="Cargo" class="form-control required" v-model="responsable.cargo" />
              </div>
              <div class="input" :class="{invalid: $v.aoe.$error}">
                  <h4 for="aoe">Acto Objeto de Estudio *</h4>
                  <input type="text" id="aoe" @blur="$v.aoe.$touch()" placeholder="Acto Objeto de Estudio" class="form-control required" v-model="aoe" />
              </div>
              <h4>Cumplimiento</h4>
              <div class="input" :class="{invalid: $v.cumplimiento.acto.$error}">
                  <label for="actoCumplimiento">Acto de Cumplimiento *</label>
                  <input type="text" id="actoCumplimiento" @blur="$v.cumplimiento.acto.$touch()" placeholder="Acto de Cumplimiento" class="form-control required" v-model="cumplimiento.acto" />
              </div>
              <div class="input" :class="{invalid: $v.cumplimiento.fechaPago.$error}">
                  <label for="fechaPago">Fecha Pago *</label>
                  <input type="text" id="fechaPago" @blur="$v.cumplimiento.fechaPago.$touch()" placeholder="Fecha Pago" class="form-control required" v-model="cumplimiento.fechaPago" />
              </div>
              <div class="input" :class="{invalid: $v.cumplimiento.valorNeto.$error}">
                  <label for="valorNeto">Valor Neto *</label>
                  <input type="text" id="valorNeto" @blur="$v.cumplimiento.valorNeto.$touch()" placeholder="Valor Neto" class="form-control required" v-model="cumplimiento.valorNeto" />
              </div>
          </div>
        </div>
        <div slot="page3">
          <div class="form-datos">
            <h4>Sentido de la condena</h4>
              <div class="input" :class="{invalid: $v.cuantiaDeLaPension.$error}">
                  <label for="cuantiaDeLaPension">Cuantia de la Pension *</label>
                  <input type="text" id="cuantiaDeLaPension" @blur="$v.cuantiaDeLaPension.$touch()" placeholder="Cuantia de la Pension" class="form-control required" v-model="cuantiaDeLaPension" />
              </div>
              <h4>Antecedentes</h4>
              <div class="input" :class="{invalid: $v.antecedentes.reconocimiento.$error}">
                  <label for="reconocimiento">Acto Inicial de Reconomiento *</label>
                  <input type="text" id="reconocimiento" @blur="$v.antecedentes.reconocimiento.$touch()" placeholder="Reconocimiento" class="form-control required" v-model="antecedentes.reconocimiento" />
              </div>
              <div class="input" :class="{invalid: $v.antecedentes.cuantiaInicial.$error}">
                  <label for="cuantia">Mesada Inicial *</label>
                  <input type="text" id="cuantia" @blur="$v.antecedentes.cuantiaInicial.$touch()" placeholder="Cuantia Inicial" class="form-control required" v-model="antecedentes.cuantiaInicial" />
              </div>
              <div class="input" :class="{invalid: $v.antecedentes.numeroSemanas.$error}">
                  <label for="numeroSemanas">Numero de Semanas *</label>
                  <textarea type="textarea" id="numeroSemanas" @blur="$v.antecedentes.numeroSemanas.$touch()" placeholder="Numero de Semanas" class="form-control required" v-model="antecedentes.numeroSemanas" />
              </div>
          </div>
        </div>
        <div slot="page6">
          <div class="form-datos">
              <div class="input" :class="{invalid: !acceptTerms}"><input id="acceptTerms" name="acceptTerms" type="checkbox" v-model="acceptTerms"> <label for="acceptTerms" class="checkbox-label">Acepto los terminos y condiciones.</label></div>
              <iframe id='pdfV' style="width:100%; height: 500px" > </iframe>
              <button @click="downloadPretension()">Descargar</button>
          </div>
        </div>
      </vue-good-wizard>
    </div>
  </template>
  
  <script>
  import { required, email, numeric, minValue, minLength, sameAs, requiredUnless } from 'vuelidate/lib/validators'
  import contratoArriendo from '../../contractTemplates/arriendo.js'
  import fireStore from '../../helpers/db'
import pretension from '../../contractTemplates/pretension';
  export default {
    data(){
      return {
        fileName: 'pretensionJunio',
        proceso: {
            // sentencia: 'Sentencia',
            // jurisdiccion: 'Ordinaria',
            // afiliado: 'Michael Perez',
            // cedula: '1130400566',
            // radicado: '11232093034849557845756',
            // despacho1: 'Juzgado 1 laboral del circuito de Cali',
            // despacho2: 'n/a',
            // fechaFallo1: '28/11/2023',
            // fechaFallo2: 'n/a',
            // pretension: 'Vejez – Indemnización Sustitutiva - Reliquidación',
            // tipoDemanda: 'demanda ordinaria laboral'

            sentencia: '',
            jurisdiccion: '',
            afiliado: '',
            cedula: '',
            radicado: '',
            despacho1: '',
            despacho2: 'n/a',
            fechaFallo1: '',
            fechaFallo2: 'n/a',
            pretension: 'Vejez – Indemnización Sustitutiva - Reliquidación',
            tipoDemanda: ''
        },
        responsable:{
            // nombre: 'Marcela Andrea Zuleta Murgas',
            // cargo: 'Subdirectora de Determinación VIII - Colpensiones'
            nombre: '',
            cargo: ''
        },
        // aoe: 'SUB 140383 del 23 de mayo de 2022',
        aoe: '',
        cumplimiento:{
            // acto: 'SUB 345862 del 12 de diciembre de 2023',
            // fechaPago: '2 de febrero de 2024',
            // valorNeto: '$ 1.628.262'
            acto: '',
            fechaPago: '',
            valorNeto: ''
        },
        // cuantiaDeLaPension: '$1.600.324',
        cuantiaDeLaPension: '',
        antecedentes:{
            // reconocimiento: 'SUB 12320 del 16 de enero de 2020',
            // numeroSemanas: '500'
            reconocimiento: '',
            cuantiaInicial: '',
            numeroSemanas: ''
        },
          acceptTerms: true,
          steps: [
              {
              label: 'Información del proceso judicial',
              slot: 'page1',
              },
              {
              label: 'Presunto Responsable/AOE/Cumplimiento',
              slot: 'page2',
              },
              {
              label: 'Sentido de la condena/Antecedentes',
              slot: 'page3',
              },
              {
              label: 'Terminar',
              slot: 'page6',
              }
          ],
          nextStepLabel: 'Siguiente',
          previousStepLabel: 'Atras',
          finalStepLabel: 'Generar'
      };
    },
    computed: {
      uploadedData () {
        return !this.$store.getters.activePretension ? null : this.$store.getters.activePretension
      }
    },
    
    methods: {
      created () {
        console.log('Entro a Pretension')
      },
      nextClicked(currentPage) {
        console.log('next clicked', currentPage)
        switch(currentPage){
            case 0:
              this.$v.proceso.$touch()
              if(this.$v.proceso.$invalid)
                  return false;
            break;
            case 1:
              this.$v.responsable.$touch()
              if(this.$v.responsable.$invalid ||this.$v.aoe.$invalid)
                  return false;
            break;
            case 2:
              this.$v.antecedentes.$touch()
              if(this.$v.antecedentes.$invalid )
                  return false;
            break;
            case 3:
              // var checked = 
              if(!this.acceptTerms){
                  return false;
              }
              
              let e = this.getPretensionContract();

              pdfMake.createPdf(e.getContractObject()).getDataUrl(function (outDoc) {
                  document.getElementById('pdfV').src = outDoc;
              });
  
              //fireStore.saveContract(contrato);
  
              break;
            default:
            break;
  
        }
        return true; //return false if you want to prevent moving to next page
      },
      downloadPretension(){
        let e = this.getPretensionContract();
        pdfMake.createPdf(e.getContractObject()).download(this.fileName);
  
      },
      getPretensionContract(){
        let contrato = { 
                  proceso: this.proceso,
                  responsable: this.responsable,
                  aoe: this.aoe,
                  cumplimiento: this.cumplimiento,
                  cuantiaDeLaPension: this.cuantiaDeLaPension,
                  antecedentes: this.antecedentes,
                  tipo: 'Pretension',
                  fileName: this.fileName
              }
              console.log('pretension',JSON.stringify(contrato));
  
              
              var e = new pretension(contrato)

              return e;
      },
      backClicked(currentPage) {
        console.log('back clicked', currentPage);
        return true; //return false if you want to prevent moving to previous page
      },
      isEmptyOrNotNull(obj) {
        return obj !== null && obj !== undefined && Object.keys(obj).length === 0 && obj.constructor === Object;
      }
    },
      validations: {
          proceso: {
            sentencia: {required},
            jurisdiccion: {required},
            afiliado: {required},
            cedula: {required},
            radicado: {required},
            despacho1: {required},
            fechaFallo1:{required},
            pretension: {required}
          },
          responsable:{
            nombre: {required},
            cargo: {required},
          },
          aoe: {required},
          cumplimiento:{
            acto: {required},
            fechaPago: {required},
            valorNeto: {required},
          },
          cuantiaDeLaPension: {required},
          antecedentes:{
            reconocimiento: {required},
            cuantiaInicial: {required},
            numeroSemanas: {required}
          },
  
          lastName: {
          required
          }
      },
    created () {
      console.log('Entro a Pretension')
      console.log(this.uploadedData)
      var isEmpty = (this.uploadedData === null);
      if(!isEmpty ){
        console.log('Uploaded data not empty ')
        for (const key of Object.keys(this.uploadedData)) {
          switch (key.trim()) {
            case 'proceso.cedula':
            case 'CEDULA AFILIADO':
              console.log(`Cedula  Handling ${key}: ${this.uploadedData[key]}`);
              this.proceso.cedula = this.uploadedData[key];
              break;
            case 'proceso.afiliado':
            case 'NOMBRE OK':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.proceso.afiliado = this.uploadedData[key];
              break;
            case 'proceso.despacho1':
            case 'DESPACHO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.proceso.despacho1 = this.uploadedData[key];
              break;
            case 'proceso.radicado':
            case 'RADICADO 23 DIGITOS':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.proceso.radicado = this.uploadedData[key];
              break;
            case 'cumplimiento.acto':
            case 'CUMPLIMIENTO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.cumplimiento.acto = this.uploadedData[key];
              break;
            case 'cumplimiento.fechaPago':
            case 'FECHA DE PAGO OK':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.cumplimiento.fechaPago = this.uploadedData[key];
              break;
            case 'cumplimiento.valorNeto':
            case 'VALOR_NETO_GIRADO':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.cumplimiento.valorNeto = this.uploadedData[key];
              break;
            case 'Nombre_Archivo':
              console.log(`Handling ${key}: ${this.uploadedData[key]}`);
              this.fileName = this.uploadedData[key];
              break;
            default:
              console.log(`Unhandled key: ${key}`);
              // Handle default case or other keys
          }
        }
      }
      // this.$store.dispatch('fetchUser2')
    }
  };
  </script>
  <style>
  .form-datos div{
      display: block;
      padding-top: 5px;
  }
  .input {
      margin: 5px auto;
    }
  
    .input label {
      display: block;
      color: #4e4e4e;
      margin-bottom: 6px;
    }
  
    .input.inline label {
      display: inline;
    }
  
    .input input {
      font: inherit;
      width: 100%;
      padding: 6px 12px;
      box-sizing: border-box;
      border: 1px solid #ccc;
    }
    .input input[type='checkbox']{
        font: inherit;
      width: auto !important;
      padding: 6px 12px;
      box-sizing: border-box;
      border: 1px solid #ccc;
    }
  
    .checkbox-label{
        display: inline !important;
    }
  
    .input textarea {
      font: inherit;
      width: 100%;
      padding: 6px 12px;
      box-sizing: border-box;
      border: 1px solid #ccc;
    }
  
    .input.inline input {
      width: auto;
    }
  
    .input input:focus {
      outline: none;
      border: 1px solid #521751;
      background-color: #eee;
    }
  
    .input.invalid label {
      color: red;
    }
  
    .input.invalid input {
      border: 1px solid red;
      background-color: #ffc9aa;
    }
  
    .input.invalid textarea {
      border: 1px solid red;
      background-color: #ffc9aa;
    }
  
    .input select {
      border: 1px solid #ccc;
      font: inherit;
    }
  
    .hobbies button {
      border: 1px solid #521751;
      background: #521751;
      color: white;
      padding: 6px;
      font: inherit;
      cursor: pointer;
    }
  
    .hobbies button:hover,
    .hobbies button:active {
      background-color: #8d4288;
    }
  
    .hobbies input {
      width: 90%;
    }
  
    .submit button {
      border: 1px solid #521751;
      color: #521751;
      padding: 10px 20px;
      font: inherit;
      cursor: pointer;
    }
  
    .submit button:hover,
    .submit button:active {
      background-color: #521751;
      color: white;
    }
  
    .submit button[disabled],
    .submit button[disabled]:hover,
    .submit button[disabled]:active {
      border: 1px solid #ccc;
      background-color: transparent;
      color: #ccc;
      cursor: not-allowed;
    }
  
    .wizard__body__step{
      max-width: 80%;
      margin: 0 auto;
      min-height: 520px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/contractWizards/pretension.vue